<template>
    <div :class="[$style['car-css'] ,$style['basket']]">
        <div :class="$style['itemsBasket']">
            <div :class="$style['contentBasket']">
                <div v-if="userProfile != null && (userProfile.user_vehicles == null || userProfile.user_vehicles.length == 0)"
                     style="margin-top: 80%">
                    <div :class="$style['contentTransaction']">
                        <v-icon>search_off</v-icon>
                        <span>هنوز خودرویی ثبت نشده است</span>
                    </div>
                </div>
                <div v-if="userProfile != null && userProfile.user_vehicles != null && userProfile.user_vehicles.length > 0"
                     :class="$style['address-box']" style="margin: 0 10px 0 10px">
                    <div v-for="(item, index) in userProfile.user_vehicles"
                         :key="index">
                        <div style="display: flex;">
                            <v-icon
                                    role="button" v-ripple @click="editItem(item, index)"
                                    style="color: #7dc353;  margin-left: 10px;">create
                            </v-icon>
                            <div style="flex: 1; height: auto; margin: 10px 0;">
                                <h4>
                                    {{ item.model }}
                                </h4>
                                <h5 style="font-size: 13px; color: #9a9696; font-weight: normal">
                                    {{ item.pelakFirst + item.pelakSecond}}
                                </h5>
                            </div>
                            <v-icon role="button" v-ripple @click="removeItem(item)">remove</v-icon>
                        </div>
                        <div style="height: 1px; background: #b7b7b7; width: 90%"></div>
                    </div>
                </div>
                <div :class="$style['btn_registration']">
                    <v-btn block color="#7ec352" large role="button" v-ripple @click="editMode = false, showModal = true"
                    >افزودن خودرو
                    </v-btn>
                </div>
            </div>
        </div>


        <v-dialog v-model="showModal" transition="scroll-y-transition">
            <v-card :class="[$style['box-modal'], $style['car-css']]">
                <div style="text-align: left" role="button" v-ripple @click="showModal = false">
                    <v-icon style="font-size: 28px;font-weight: bold;padding: 5px 5px;">clear
                    </v-icon>
                </div>
                <div style="margin: 0 15px 0 15px">
                    <p>مدل خودرو خود را وارد نمائید</p>
                    <v-text-field
                            v-model="model"
                            solo
                            placeholder="مثلا: پژو 206"
                            append-icon="airport_shuttle">
                    </v-text-field>

                    <div style="display: flex; text-align: center">
                        <div style="display: flex; height: 50px; width: 40%">
                            <span style="background: #7dc353;padding: 10px">ایران</span>
                            <v-text-field
                                    solo
                                    v-model="pelakSecond"
                                    placeholder="33">
                            </v-text-field>
                        </div>
                        <v-text-field
                                v-model="pelakFirst"
                                solo
                                placeholder="45 ت 444">
                        </v-text-field>
                    </div>
                    <p>رنگ خودرو را انتخاب نمائید</p>
                    <div style="display: flex; justify-content: space-evenly;">
                        <p v-for="(item, index) in allColor" :key="index" role="button" v-ripple @click="SelectColor(item.id)"
                           :style="'width: 40px; height: 40px; border-radius: 50%; border: 1px solid gray;'
                            + 'background-color' + ':' + item.title"></p>
                    </div>
                    <div>
                        <v-text-field
                                solo
                                v-model="color"
                                placeholder="سایر رنگ ها، مثلا: قرمز">
                        </v-text-field>
                    </div>
                </div>

                <v-btn
                        style="width: 100%; background-color: #7dc353; color: white;
                     padding: 0!important; margin: 20px 0 0 0 !important;"
                        role="button" v-ripple @click="setData">
                    ثبت
                </v-btn>
            </v-card>
        </v-dialog>

        <v-snackbar
                v-model="snackbar"
                top
                :color="snackbar_color"
                timeout="6000">
            {{snackbar_text}}
            <template v-slot:action="{ attrs }">
                <v-btn dark text v-bind="attrs" role="button" v-ripple @click="snackbar = false">
                    <v-icon>cancel</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>
<script>
    import oracle from "@/utils/oracle";

    export default {
        name: "Cars",
        data: () => ({
            snackbar_color: null,
            snackbar_text: null,
            snackbar: false,
            color: null,
            pelakFirst: null,
            pelakSecond: null,
            model: null,
            showModal: false,
            oracle: oracle,
            userProfile: null,
            editMode: false,
            editIndex: 0,
            allColor: [
                {title: 'blue', id: 'آبی'},
                {title: 'yellow', id: 'زرد'},
                {title: 'White', id: 'سفید'},
                {title: 'black', id: 'مشکی'},
                {title: 'Gray', id: 'خاکستری'},
                {title: 'green', id: 'سبز'},
            ]
        }),
        methods: {
            SelectColor(itemid) {
                this.color = itemid
            },
            editItem(item, index) {
                this.showModal = true;
                this.editMode = true
                this.editIndex = index
                this.pelakSecond = item.pelakSecond;
                this.pelakFirst = item.pelakFirst;
                this.model = item.model;
                this.color = item.color;
            },
            removeItem(item) {
                let vehicles = [];
                for (let i = 0; i < this.userProfile.user_vehicles.length; i++) {
                    if (item != this.userProfile.user_vehicles[i]) {
                        vehicles.push(this.userProfile.user_vehicles[i]);
                    }
                }
                oracle.axios("user/edit", {user_vehicles: vehicles}, this.FinalSetMap);
            },
            FinalSetMap() {
                this.showModal = false;
                this.fetchData()
            },
            fetchData() {
                oracle.axios("user/getProfile", {}, (response) => {
                    this.userProfile = response.data;
                });
            },
            setData() {
                if (oracle.isEmpty(this.model)) {
                    this.snackbar_text = "لطفا مدل خودرو را با دقت وارد نمایید"
                    this.snackbar_color = "error"
                    this.snackbar = true;
                    return
                }
                let data = {
                    model: this.model,
                    color: this.color,
                    pelakFirst: this.pelakFirst,
                    pelakSecond: this.pelakSecond,
                }
                let array
                if (!this.editMode) {
                    if (
                        this.userProfile.user_vehicles &&
                        this.userProfile.user_vehicles.length > 0
                    ) {
                        array = this.userProfile.user_vehicles;
                        array.push(data);
                    } else {
                        array = [data];
                    }
                } else {
                    array = this.userProfile.user_vehicles
                    array[this.editIndex] = data
                }
                oracle.axios(
                    "user/edit",
                    {user_vehicles: array},
                    this.FinalSetMap
                );
            },
        },
        mounted() {
            this.fetchData()
        },
    };
</script>
<style module>
    .car-css .MainMapCss_Sub {
        height: calc(100% - 56px) !important;
        margin-top: 56px;
        display: flex;
        position: absolute;
        z-index: 30000;
        width: 100%;
        top: 0;
        left: 0;
    }

    .car-css {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background: #fff;
    }

    .car-css .footerBasket {
        box-shadow: 0 0 3px -1px #707070;
        background: #fff;
    }

    .car-css .header-basket {
        background: #e1e3e5;
        padding: 15px 10px;
    }

    .car-css .header-basket h2 {
        font-size: 12px;
        color: #000;
        font-weight: 100;
        text-align: justify;
    }

    .car-css .btn_registration {
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
    }

    .car-css .btn_registration button {
        height: 60px !important;
        border-radius: 0;
        font-size: 15px;
        color: #fff !important;
    }

    .car-css .amountBasket {
        display: flex;
        justify-content: space-between;
        font-weight: bold;
        padding: 15px;
    }

    .car-css .btnaddAddress button {
        margin: 0 auto;
        display: flex;
        width: 100%;
    }

    .car-css .imageBasket {
        width: 100px;
        height: 100px;
        object-fit: contain;
        /*display: flex;*/
    }

    .car-css .imageBasket-top {
        display: flex;
        align-items: center;
    }

    .car-css .imageBasket-top span {
        font-size: 10px;
    }

    .car-css .imageBasket img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }

    .car-css .img-basket img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .car-css .textproductBasket span:nth-child(3),
    .car-css .amountBasket span:last-child {
        color: #7ec352 !important;
    }

    .car-css .productBasket {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .car-css .addproductBasket ul {
        display: flex;
    }

    .car-css .addproductBasket ul li {
        padding: 0 5px;
    }

    .car-css .textfield {
        margin-right: 15px;
        margin-left: 15px;
    }

    .car-css .textfield input, .car-css .textfield textarea {
        font-size: 15px !important;
    }


    .car-css .textfield label {
        font-size: 12px !important;
    }

    .car-css .contentBasket {
        padding: 15px 10px;
    }

    .car-css .closetBasket .v-icon {
        color: #cccccc;
    }

    .car-css .itemsBasket {
        height: 80%;
        overflow: auto;
    }

    .car-css .btnaddAddress .v-icon {
        padding-left: 5px;
    }

    .car-css .btnaddAddress a {
        text-decoration: none;
    }

    .car-css .box-modal {
        padding: 10px 15px;
    }

    .car-css .box-modal input::placeholder {
        font-size: 12px;
    }

    .car-css .headline-tv {
        display: flex;
        justify-content: space-between;
        padding: 10px;
    }

    .car-css .headline-tv span {
        font-size: 12px !important;
        font-weight: bold;
    }

    .car-css .backpages,
    .car-css .backpages .v-icon {
        color: #cad5d1;
        display: flex;
        align-items: center;
        font-weight: 100;
    }

    .car-css .backpages .v-icon {
        font-size: 20px !important;
    }

    .car-css .backpages span {
        font-weight: 100;
    }

    .car-css .btnAddprice button {
        margin: 15px 0;
        background: #26c6da !important;
        color: #fff !important;
        width: 100%;
        height: 60px;
    }

    .car-css .btnAddprice button {
        margin-bottom: 0;
    }

    .car-css .btn-accept {
        width: 80%;
    }

    .car-css .contentTransaction i {
        color: #7ec352;
        font-size: 5em;
        margin: 0 auto;
    }

    .car-css .contentTransaction span {
        font-size: 13px;
    }

    .car-css .contentTransaction {
        align-items: center;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: center;
    }

    .car-css .contentTransaction .v-icon {
        font-size: 4em;
    }

    .car-css .contentTransaction span {
        font-size: 12px;
    }
</style>
